import React from 'react';
import { withStyles } from '@material-ui/core';

import styles from './style';
import Divider from '../Divider';
import Link from '../atomic/Link';

const RedirectOrLogout = () => {
  return (
    <>
      <Divider>ELLER</Divider>
      <div style={{ textAlign: 'center' }}>
        <Link to="/logout">
          <strong>Logg ut</strong>
        </Link>
      </div>
    </>
  );
};

export default withStyles(styles)(RedirectOrLogout);
